export const idleConstants = {
    LOADING: 'loading',
    SUCCEEDED: 'succeeded',
    IDLE: 'idle',
    ERROR: 'error',
    RESET: 'reset'
};